import { createFileRoute } from '@tanstack/react-router'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { ManualDrawingForm } from '@/src/components/manage/forms/ManualDrawingForm'

export const Route = createFileRoute('/_manage/manage/drawings/new')({
  component: NewDrawingPage,
})

function NewDrawingPage() {
  return (
    <div className="bg-background text-foreground">
      <AdminToolbar>
        <AdminToolbar.BackButton to="/manage/drawings" />
      </AdminToolbar>
      <div className="mt-4">
        <ManualDrawingForm />
      </div>
    </div>
  )
}
